/**
 * Main Entry Point
 * Initializes React application with StrictMode
 */

// FIRST: the support report's console and page history, from page load.
import './components/layout/supportConsoleBoot';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { maybeRedirectLegacyHash } from './routing/LegacyHashRedirect';

// Initialize config service
import configService from '@services/config';


function bootReact() {
  configService.initialize().then(() => {
    console.log('✅ Configuration initialized');
    ReactDOM.createRoot(document.getElementById('root')!).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  }).catch((error) => {
    console.error('❌ Failed to initialize configuration:', error);
    // Render app anyway with fallback config.
    ReactDOM.createRoot(document.getElementById('root')!).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  });
}

// 90-day migration shim — rewrites old /#/?tenant=X URLs to /X/...
// BEFORE React renders so the legacy form is never visible. When the
// shim issues a redirect it returns true and we skip booting React on
// the stale URL.
// Remove after 2026-08-25 along with the LegacyHashRedirect file.
if (!maybeRedirectLegacyHash()) {
  bootReact();
}
